export default __webpack_public_path__ + "static/mode-paired-6350bfeb6d83bd541f82bd0eba479e1e.png";